import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import type { ContentType } from './types';

const { spacing } = theme;

export const overlay = css`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  opacity: 0.75;
  background-color: var(--neutral-black-base);
  pointer-events: none;
`;

export const activationModal = (content: ContentType) => css`
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-base);
  text-align: center;

  img {
    margin-top: ${spacing.xxxxl}px;
  }

  h2 {
    margin: 0;
    padding-top: ${spacing.sm}px;
    color: var(--brand-bluple-base);
  }

  p {
    padding: 0 96px;
    margin-bottom: ${spacing.xxl}px;
    text-indent: 10px;
  }

  button {
    margin-bottom: ${spacing.xxl}px;
  }

  ${mediaQuery(
    { max: minBreakpoints.M },
    css`
      img {
        width: 298px;
        height: 78px;
        margin-top: ${spacing.xxl}px;
      }

      h2 {
        padding-top: ${spacing.lg}px;
      }

      p {
        padding: 0 ${spacing.xl}px;
        text-align: center;
      }

      button {
        margin-bottom: 0;
      }
    `,
  )}

  ${content === 'alreadyAMember' &&
  css`
    h2 {
      padding: ${spacing.sm}px 200px;
    }

    ${mediaQuery(
      { max: minBreakpoints.M },
      css`
        h2 {
          padding: ${spacing.lg}px 10px 0;
        }
      `,
    )}
  `}

  ${content === 'alreadyActivated' &&
  css`
    p {
      padding: 0 100px;
    }

    ${mediaQuery(
      { max: minBreakpoints.M },
      css`
        p {
          padding: 0 ${spacing.xl}px;
        }
      `,
    )}
  `}
`;

export const highlightedText = css`
  color: var(--brand-purple-base);
`;

export const linkText = css`
  color: var(--brand-purple-base);
  text-decoration: underline;
  cursor: pointer;
`;
